import '../../screens/reservation.css'
import '../../App.css'
import CONTENT from '../../contents/reservation'
import { useLang } from '../../hook/UseLang'
const ProgressBar = ({page}) => {
    const [lang, setLang] = useLang()
    return (                    
    <ul class="bf-stepper bf-stepper-scale">
        <li class={"bf-step " + (page === 0 ? 'bf-step-active': page >= 1 && 'bf-step-complete')}>
            <div class="bf-step-label">{CONTENT.searchAva[lang]}</div>
            <div class="bf-step-circle">
                <div className='bf-step-fill w-full h-full'></div>
            </div>
        </li>
        <li class={"bf-step " + (page === 1 ? 'bf-step-active' : page >= 2 && 'bf-step-complete')}>
            <div class="bf-step-label">{CONTENT.roomRate[lang]}</div>
            <div class="bf-step-circle">
                <div className='bf-step-fill w-full h-full'></div>
            </div>
        </li>
        <li class={"bf-step " + (page === 2 ? 'bf-step-active' : page >= 2 && 'bf-step-complete')}>
            <div class="bf-step-label">{CONTENT.guestInfo[lang]}</div>
            <div class="bf-step-circle">
                <div className='bf-step-fill w-full h-full'></div>
            </div>
        </li>
    </ul>)
}

export default ProgressBar;